import * as React from "react";
import { ColumnProps } from "../../../../../components/DataGrid/CellColumnProps";
import { Key } from "../../../../../models";

const styles = require('./MultiselectColumn.local.css');

export interface MultiselectProps extends ColumnProps
{
    toggle: (datum: any, row: number) => void;
    toggleAll: () => void;
    datumKey?: (datum: any) => Key;

    // this one will be injected by Container
    disabled?: boolean;
    selected?: Set<any>;
    allSelected?: boolean;
}

export const multiselectPropsFrom = (props: MultiselectProps) => ({
        renderHeader: () => {
            let divRef;
            return props.disabled ? null : (
                <div onClick={e => (divRef === e.target) && props.toggleAll()} ref={e => divRef = e} className={styles.HeaderCell}>
                    <input type="checkbox" checked={props.allSelected} onChange={() => props.toggleAll()} />
                </div> 
            )
        },
        headerClassName: styles.MultiselectColumn,
        ...props
    }
);

// This columns renders seleciton checkbox
export class MultiselectColumn extends React.Component<MultiselectProps, any>
{
    private tdRef: HTMLTableDataCellElement;
    
    render() {
        const { datum, row, selected, toggle, datumKey } = this.props;
        
        return (
            <td className="text-center" onClick={e => (e.target === this.tdRef) && toggle(datum, row)} ref={e => this.tdRef = e}>
                <input type="checkbox" checked={selected.has(datumKey ? datumKey(datum) : datum.id)} onChange={e => toggle(datum, row)} />
            </td>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Columns/MultiselectColumn/MultiselectColumn.tsx